import { render, staticRenderFns } from "./updpwd.vue?vue&type=template&id=0407185e&scoped=true"
import script from "./updpwd.vue?vue&type=script&lang=js"
export * from "./updpwd.vue?vue&type=script&lang=js"
import style0 from "./updpwd.vue?vue&type=style&index=0&id=0407185e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0407185e",
  null
  
)

export default component.exports